import type { RefObject } from "react";
import { useRef, useState } from "react";

interface IResult<T extends Element = Element> {
    ref: RefObject<T | null>;
    isTruncated: boolean;
    recalculate: () => void;
}

function useIsTruncatedElement<T extends Element = Element>(defaultTruncated = false): IResult<T> {
    const ref = useRef<T>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    const recalculate = () => {
        const element = ref.current;

        const isTruncatedHorizontally: boolean = element ? element.scrollWidth > element.clientWidth : defaultTruncated;
        const isTruncatedVertically: boolean = element ? element.scrollHeight > element.clientHeight : defaultTruncated;

        const currentIsTruncated = isTruncatedHorizontally || isTruncatedVertically;

        if (isTruncated !== currentIsTruncated) {
            setIsTruncated(currentIsTruncated);
        }
    };

    return {
        ref,
        isTruncated,
        recalculate,
    };
}

export default useIsTruncatedElement;
